import * as Yup from 'yup';

export const CardReplacementSchema = Yup.object().shape({
  accountToLink: Yup.string().required('Select account to link'),
  accountToDebit: Yup.string().required('Select Account to debit for Charges'),
  reason: Yup.string().required('Select a reason for replacement'),
});
